import { createGlobalState } from '@vueuse/core';
import type { FeatureName, FeatureFlags } from '~/types/feature.types';

export const useFeatureStore = createGlobalState(
  () => {
    const { gtmPush } = useTracking();
    const { user } = useUserStore();

    const state = reactive<{
      features: FeatureFlags;
    }>({
      features: {},
    });

    const features = computed(() => state.features);
    const featuresLoaded = ref(false);

    const isEnabled = (featureName: FeatureName): boolean => {
      return !!state.features[featureName];
    };

    const updateFeatures = async () => {
      try {
        const data = await $fetch<FeatureFlags>('/api/auth/user/features');
        if (data) {
          state.features = data;

          const enabledFeatures = Object.entries(data)
            .filter(([, enabled]) => enabled)
            .map(([feature]) => feature)
            .join(',');

          gtmPush({
            event: 'enabled_features',
            features: enabledFeatures,
            user: {
              plan_type: user.value?.subscription?.type,
            },
          });
        }

      } catch (error) {
        console.error('Failed to fetch user features:', error);
      } finally {
        featuresLoaded.value = true;
      }
    };

    return {
      features,
      isEnabled,
      updateFeatures,
      featuresLoaded: computed(() => featuresLoaded.value),
    };
  },
);